/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getAppConfig} from '../api'

 export const useQueryGetAppConfig = createReactQueryHook('getAppConfig', getAppConfig)
